<template>
    <div>

        <div class="mainWrapper">
            <MainSideBar />

            <div class="rightContentWrapper">

                <div class="topNav">
                    <TopBarVue />
                </div>

                <div class="innerContainer">

                    <div class="theHeaderWrapper">

                        <div style="display: flex; align-items: center;">
                            <i @click="$router.go(-1)"
                                style="font-size: 25px; font-weight: bold; cursor: pointer; margin-right: 10px;"
                                class="bi bi-arrow-left"></i>

                            Back
                        </div>


                        <div class="theRightBox">




                        </div>


                    </div>


                    <div class="userHeaderBox">


                        <div class="userAvatarBox">

                            <div class="theUserCircle">

                                <div v-if="templateStore.the_user">

                                    {{ templateStore.firstNameAndLastNameLetters() }}

                                </div>



                            </div>


                        </div>

                        <div class="userNameBox">

                            <div class="theNameBox">

                                {{ templateStore.the_user.name }}


                            </div>

                            <div class="theInfoSection">

                                <div v-if="templateStore.the_template_inspection_normal_user">

                                    Permission: {{ templateStore.theUserRoleType() }} |
                                    Email: {{ templateStore.the_user.email }} |
                                    Date added: {{ templateStore.formatDate(templateStore.the_user.created_at) }}
                                </div>



                            </div>

                        </div>




                    </div>



                    <div class="siteTabWrapper">

                        <div v-for="(tabOption, index) in templateStore.userDetailsTabOptions" :key="index"
                            class="siteTabItem"
                            :class="{ siteTabItemSelected: tabOption.type === templateStore.userDetailCurrentTabType }"
                            @click="setUserDetailTabTypeAndResetSearchQuery(tabOption.type)">

                            {{ tabOption.name }}

                        </div>


                    </div>



                    <div v-if="templateStore.userDetailCurrentTabType === 'groups'" class="table-responsive">


                        <div class="inspectionsHeaderWrapper">

                            <div class="theLeftBox">


                                <div style="text-align: left; font-size: 16px; margin-bottom: 15px;">
                                    <b>Groups</b>
                                </div>

                                <div>

                                    <input v-model="searchQuery" style="width: 300px;" type="text" class="form-control titleInput"
                                        placeholder="Search..." />

                                </div>



                            </div>

                            <div class="theRightSide">



                            </div>


                        </div>


                        <div v-if="templateStore.the_groups.length > 0">

                            <table class="table table-hover">

                                <thead>
                                    <tr>
                                        <th scope="col" class="py-3 text-start">Name</th>
                                        <th scope="col" class="py-3 text-start">Description</th>
                                        <th scope="col" class="py-3 text-start">Users</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <tr v-for="(the_group, index) in filteredGroupsList" :key="index"
                                    @click="templateStore.goToAGroup(the_group.team.uuid)"
                                    style="cursor: pointer;"
                                    >

                                        <td class="py-3 text-start">

                                            <div v-if="the_group.team">

                                                {{ the_group.team.name }}

                                            </div>

                                        </td>

                                        <td class="py-3 text-start">

                                            {{ templateStore.limitText(the_group.team.desc) }}

                                        </td>

                                        <td class="py-3 text-start">

                                            <div v-if="the_group.team && the_group.team.template_inspection_team_users">

                                                {{ the_group.team.template_inspection_team_users.length }}

                                            </div>

                                            

                                        </td>



          


                                    </tr>

                                </tbody>

                            </table>

                        </div>

                        <div v-else>
                            {{ templateStore.the_user.fname }} is not added to any groups yet.
                        </div>





                    </div>

                    <div v-if="templateStore.userDetailCurrentTabType === 'sites'" class="table-responsive">


                        <div class="inspectionsHeaderWrapper">

                            <div class="theLeftBox">


                                <div style="text-align: left; font-size: 16px; margin-bottom: 15px;">
                                    <b>Sites</b>
                                </div>

                                <div>

                                    <input v-model="searchQuery" style="width: 300px;" type="text" class="form-control titleInput"
                                        placeholder="Search..." />

                                </div>



                            </div>

                            <div class="theRightSide">




                            </div>


                        </div>


                        <table class="table table-hover">

                            <thead>
                                <tr>
                                    <th scope="col" class="py-3 text-start">Name</th>
                                    <th scope="col" class="py-3 text-start">Description</th>
                                    <th scope="col" class="py-3 text-start">Users</th>
                                </tr>
                            </thead>

                            <tbody>

                                <tr v-for="(the_site, index) in filteredSiteList" :key="index"
                                @click="templateStore.goToASite(the_site.site.uuid)"
                                style="cursor: pointer;"
                                >

                                    <td class="py-3 text-start">

                                        <div v-if="the_site.site">
                                            {{ the_site.site.name }}
                                        </div>

                                    </td>

                                    <td class="py-3 text-start">

                                        {{ templateStore.limitText(the_site.site.desc) }}

                                    </td>

                                    <td class="py-3 text-start">

                                        <div v-if="the_site.site && the_site.site.template_site_users">

                                            {{ the_site.site.template_site_users.length }}

                                        </div>

                                    </td>






                                </tr>

                            </tbody>

                        </table>



                    </div>





                </div>






            </div>
        </div>










    </div>
</template>

<script setup>
import MainSideBar from "@/components/Inspections/MainSideBar";
import TopBarVue from "@/components/TopBar.vue";
import { onMounted, defineProps, ref, computed } from 'vue';
import { useTemplateStore } from "@/stores/TemplateStore";


const templateStore = useTemplateStore();




const props = defineProps({
    template_inspection_normal_user_uuid: String
})

const searchQuery = ref('');

const filteredGroupsList = computed(() => {
  return templateStore.the_groups.filter(the_group =>
    the_group?.team && 
    the_group.team.name.toLowerCase().includes(searchQuery.value.toLowerCase())
  ) || [];
});


const filteredSiteList = computed(() => {
  return templateStore.the_sites.filter(the_site =>
    the_site?.site && 
    the_site.site.name.toLowerCase().includes(searchQuery.value.toLowerCase())
  ) || [];
});


const setUserDetailTabTypeAndResetSearchQuery = (type) => {

    templateStore.userDetailCurrentTabType = type
    searchQuery.value = ''

}


onMounted(() => {

    templateStore.fetchAInspectionUserDetail(props.template_inspection_normal_user_uuid)

})



</script>

<style scoped>
.mainWrapper {
    /* background-color: aliceblue; */
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.rightContentWrapper {
    /* overflow-y: auto; */
    width: 83%;
    display: flex;
    flex-direction: column;
}

.contentContainer {
    /* overflow-y: auto; */
    background-color: rgb(208, 28, 55);
    /* margin: 30px; */
    margin-top: 100px;
}

.rightColumns {
    /* display: flex;
  flex-direction: column; */
}

.topNav {
    background-color: blue;
}

.innerContainer {
    /* margin-top: 200px; */
    /* background-color: blueviolet; */
    overflow-y: auto;
    padding-top: 30px;
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 100px;
}

.theHeaderWrapper {
    display: flex;
    justify-content: space-between;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    /* background-color: aqua; */
}

.searchBarWrapper {
    margin-top: 15px;
    width: 100%;
    padding-bottom: 20px;
    /* background-color: rgb(22, 166, 37); */
}

.theBar {
    width: 350px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 10px;
}

.button-6 {
    align-items: center;
    /* background-color: #FFFFFF; */
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0.25rem;
    box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.85);
    cursor: pointer;
    display: inline-flex;
    font-family: system-ui, -apple-system, system-ui, "Helvetica Neue", Helvetica,
        Arial, sans-serif;
    font-size: 16px;
    font-weight: 600;
    justify-content: center;
    line-height: 1.25;
    margin: 0;
    min-height: 3rem;
    padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
    position: relative;
    text-decoration: none;
    transition: all 250ms;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    vertical-align: baseline;
    width: auto;
}

.button-6:hover,
.button-6:focus {
    border-color: rgba(0, 0, 0, 0.15);
    box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
    color: rgba(0, 0, 0, 0.65);
}

.button-6:hover {
    transform: translateY(-1px);
}

.button-6:active {
    background-color: #f0f0f1;
    border-color: rgba(0, 0, 0, 0.15);
    box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
    color: rgba(0, 0, 0, 0.65);
    transform: translateY(0);
}

.tableWrapper {
    margin-top: 20px;
    /* background-color: aqua; */
    width: 100%;
}

.my-custom-table tbody tr td {
    padding-top: 20px;
    /* Adjust the value as needed */
    padding-bottom: 20px;
    /* Adjust the value as needed */
}

.my-custom-table th {
    padding-bottom: 20px;
}

.my-custom-table th,
.my-custom-table td {
    text-align: left;
    /* Aligns text to the left */
    padding-left: 20px;
    padding-right: 20px;
}

.campName {
    text-decoration: none;
    color: inherit;
}

.campName:hover {
    color: rgb(10, 159, 92);
    cursor: pointer;
    text-decoration: none;
}

.iconsRow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.theActionIcon {
    font-weight: bolder;
    font-size: 18px;
    color: rgb(5, 2, 2);
    cursor: pointer;
}

.theActionIcon:hover {
    cursor: pointer;
    color: rgb(30, 158, 30);
    scale: 1.3;
    transition: 1s;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    /* Semi-transparent black background */
    display: flex;
    justify-content: center;
    /* Center horizontally */
    align-items: center;
    /* Center vertically */
    z-index: 999;
    /* Ensure the modal is on top */
}

/* Styles for the modal box */
.modal-box {
    background-color: white;
    width: 1100px;
    padding: 20px;
    border-radius: 2px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-content {
    text-align: center;
}

.model-box-header {
    display: flex;
    justify-content: space-between;
    /* background-color: antiquewhite; */
    height: 40px;
    margin-bottom: 15px;
}

.form-control {
    background-color: rgb(243, 246, 246);
}

.createBTN {
    width: 100%;
    margin-top: 20px;
}

.noTeamBox {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
    width: 100%;
}

.noMatchBox {
    background-color: red;
    width: 100%;
}

.loadMoreBtn {
    background-color: black;
    border-radius: 10px;
}

.inviteInput {
    width: 500px;
    font-size: 13px;
    cursor: pointer;
}

.tabsWrapper {
    display: flex;
    width: 100%;
    /* background-color: #a9baba; */
}


.tabItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: #fdfdfd;
    padding: 30px;
    border: 1.5px solid #c3d4cb;
    cursor: pointer;
    margin: 10px;
    border-radius: 10px;
}

.tabItem:hover {

    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: #fdfdfd;
    padding: 30px;
    border: 1.5px solid #c3d4cb;
    cursor: pointer;
    margin: 10px;
    border-radius: 10px;
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);

}

.tabItemSelected {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
    padding: 30px;
    border: 1.5px solid #c3d4cb;
    cursor: pointer;
    margin: 10px;
    border-radius: 10px;
}



.iconDrop {
    cursor: pointer;
}

.button-13 {
    background-color: #fff;
    border: 1px solid #d5d9d9;
    border-radius: 8px;
    box-shadow: rgba(213, 217, 217, 0.5) 0 2px 5px 0;
    box-sizing: border-box;
    color: #0f1111;
    cursor: pointer;
    display: inline-block;
    font-family: "Amazon Ember", sans-serif;
    font-size: 13px;
    line-height: 29px;
    padding: 0 10px 0 11px;
    position: relative;
    text-align: center;
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    vertical-align: middle;
    min-width: 100px;
}

.button-13:hover {
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
}

.emptyTableBox {
    margin-top: 100px;
}


.groupBtn {
    border: none;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    border-radius: 15px;
    font-size: 15px;
    margin-right: 25px;
    padding: 5px;
    padding-left: 20px;
    padding-right: 20px;
}

.groupBtn:hover {
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
}

.theRightBox {
    display: flex;
    /* background-color: gray; */
}

.dropdown-item:hover {
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
    color: black;
}


.theSearchBox {
    width: 100%;
    /* background-color: rgb(255, 136, 0); */
    padding-bottom: 20px
}

.theTableBox {
    width: 100%;
    overflow-y: auto;
    height: 500px;

}



.addUsersBox {
    /* background-color: green; */
    width: 100%;
    padding-top: 20px;

}


.theTableWrapper {
    width: 100%;
    /* background-color: yellow; */
    margin-top: 40px;
}

.selectSupBox {
    display: flex;
    width: 100%;
    border-radius: 7px;
    padding: 10px;
    max-height: 100px;
    overflow-y: auto;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    cursor: pointer;
    background-color: #f2f2f2;
}

.theSupPill {
    margin: 7px
}



.innerBox {
    /* background-color: red; */
    overflow-y: auto;
    width: 100%;
    height: 500px;
    padding: 12px;
}


.talkItem {
    display: flex;
    flex-direction: row;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 10px;
    margin-bottom: 25px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
}

.talkItem:hover {
    background-color: rgb(249, 253, 252);
}

.talkLeft {
    display: flex;
    flex-direction: column;
    padding: 5px;
    width: 80%;
    /* background-color: #aadada; */
}

.talkRight {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20%;
    /* padding: 10px; */
    /* background-color: #3ddbdb; */
}

.talkTitle {
    /* background-color: #d9e7ff; */
    text-align: left;
    font-weight: bold;
    padding: 6px;
}


.groupActionBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    /* background-color: gray; */
}

.siteTabWrapper {
    display: flex;
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
}



.siteTabItem {
    width: 150px;
    font-size: 13px;
    font-weight: bold;
    /* background-color: gray; */
    padding: 5px;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    cursor: pointer;
}

.siteTabItemSelected {
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
    width: 150px;
    font-size: 13px;
    font-weight: bold;
    padding: 5px;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    cursor: pointer;
}

.siteTabItem:hover {
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
}

.membersHeaderWrapper,
.inspectionsHeaderWrapper,
.actionsHeaderWrapper,
.issuesHeaderWrapper,
.detailsHeaderWrapper {
    display: flex;
    align-items: center;
    width: 100%;
    /* background-color: gray; */
    margin-bottom: 18px;
}

.theLeftBox {
    display: flex;
    width: 50%;
    flex-direction: column;
    justify-content: flex-start;
    /* background-color: yellow; */
    padding-left: 5px;
}

.theRightSide {
    display: flex;
    justify-content: flex-end;
    width: 50%;
    /* background-color: rgb(121, 255, 133); */
}

.titleInput {
    border: 1px solid rgb(197, 197, 197);
}


.viewReportBtn {
    font-size: 14px;
    color: rgb(19, 76, 19);
    cursor: pointer;
    font-weight: bold;
}

.viewReportBtn:hover {
    text-decoration: underline;
    color: rgb(71, 162, 71);
    font-weight: bold;
}

.startInspectionBtn {
    padding-top: 5px;
    padding-bottom: 5px;
    border: none;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    font-size: 12px;
    font-weight: bold;
}

.startInspectionBtn:hover {
    color: green;
}

/* 
.siteBoxWrapper{
    width: 100%;
 
} */


.boxItem {
    display: flex;
    justify-content: space-between;
    width: 70%;
    border-radius: 10px;
    padding: 20px;
    border: 1px #dfeae6 solid;
    margin-bottom: 20px;
}

.theLefty {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* background-color: yellow; */

}


.theRighty {
    display: flex;
    align-items: center;
}


.theNameArea {
    font-size: 18px;
    margin-bottom: 10px;
    width: 100%;
    /* background-color: green; */
    text-align: left;
}

.userHeaderBox {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    border-radius: 10px;
    width: 100%;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    padding: 15px;
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
}

.userAvatarBox {
    display: flex;
    justify-content: center;
    /* background-color: yellow; */
    padding: 20px;
}

.userNameBox {
    /* background-color: rgb(206, 205, 205); */
}

.theUserCircle {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    background-color: rgb(251, 245, 245);
    height: 100px;
    width: 100px;
    border-radius: 100%;
    border: 3px solid #ffffff;
    font-size: 20px;
    color: #0f1111;
    font-weight: bold;
}

.theNameBox {
    /* background-color: green; */
    font-size: 22px;
    font-weight: bold;
}

.theInfoSection {
    /* background-color: orange; */
    margin-top: 15px;
    font-size: 16px;
}


.linkStyle {
    text-decoration: none;
    color: inherit;
}

</style>